import { apiClient } from '@/api/apiClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { USER_SESSION_QUERY_KEY } from '@/features/auth/hooks/auth'

export function useUpdateUserLanguage() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (language: string) => {
      await apiClient.put('/v1/user/language', { language })
      queryClient.invalidateQueries({ queryKey: [USER_SESSION_QUERY_KEY] })
    }
  })
}

export function useVerifyEmailWithCode() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (verificationCode: string) => {
      await apiClient.post('/v1/user/email-verification/verify-code', { verificationCode })
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [USER_SESSION_QUERY_KEY] })
    }
  })
}

export function useSendEmailVerificationCode() {
  return useMutation({
    mutationFn: async () => {
      await apiClient.post('/v1/user/email-verification/send-code')
    }
  })
}

export function useUpdateUserName() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: { firstName: string; lastName: string }) => {
      await apiClient.put('/v1/user/name', payload)
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [USER_SESSION_QUERY_KEY] })
    }
  })
}
